// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/3d-druck/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const p3dDruckDE: PageEntry = {
  id: "post.3d-druck",
  locale: "de",
  slug: "3d-druck",
  seo: {
    title: "Glossar: 3D-Druck einfach erklärt | Dietz GmbH",
    description: "Der 3D-Druck, auch als additive Fertigung bekannt, ist ein Fertigungsprozess, bei dem dreidimensionale Objekte schichtweise aufgebaut werden. Dies geschieht durch das Ablagern von ",
  },
  type: "post",
  h1: "Glossar: 3D-Druck einfach erklärt",
  intro: "Der 3D-Druck, auch als additive Fertigung bekannt, ist ein Fertigungsprozess, bei dem dreidimensionale Objekte schichtweise aufgebaut werden. Dies geschieht durch das Ablagern von Materialien wie Kunststoffen, Metallen oder Keramiken. Der 3D-Druck ermöglicht die Herstellung komplexer Strukturen und Prototypen mit hoher Präzision. Dieses Verfahren findet in verschiedenen Branchen Anwendung, von der Herstellung von Prototypen bis zur Produktion von maßgeschneiderten Bauteilen. Die Technologie hat sich in den letzten Jahren rasant entwickelt und spielt eine entscheidende Rolle in der modernen Fertigungsindustrie.",
  blocks: [

  ],
};
